var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle-button",on:{"click":_vm.toggle}},[_c('svg-icon',{attrs:{"icon-class":_vm.icon}}),_c('el-button',{staticClass:"name-style",attrs:{"type":"text","size":"small"}},[_vm._v(_vm._s(_vm.buttonName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }